import React, { useState } from 'react';
import './Sidebar.css';

const Sidebar = ({ activeService, setActiveService }) => {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-header">
        <span className="hamburger" onClick={() => setIsOpen(!isOpen)} title="Toggle menu">☰</span>
      </div>
      <div className="sidebar-content" style={{ opacity: isOpen ? 1 : 0, pointerEvents: isOpen ? 'auto' : 'none', transition: 'opacity 0.3s' }}>
        <h2 className="sidebar-title">Services</h2>
        <ul className="sidebar-menu">
          <li 
            className={`sidebar-item ${activeService === 'ai_score' ? 'active' : ''}`}
            onClick={() => { 
                if(isOpen) setActiveService('ai_score'); 
                window.history.pushState({}, '', '/ai_score');
            }}
          >
            {activeService === 'ai_score' ? '• ' : '  '} AI Score
          </li>
          <li 
            className={`sidebar-item ${activeService === 'resume_creator' ? 'active' : ''}`}
            onClick={() => { 
                if(isOpen) setActiveService('resume_creator'); 
                window.history.pushState({}, '', '/');
            }}
          >
            {activeService === 'resume_creator' ? '• ' : '  '} Resume Creator
          </li>
          <li 
            className={`sidebar-item ${activeService === 'job_finder' ? 'active' : ''}`}
            onClick={() => { 
                if(isOpen) setActiveService('job_finder'); 
                window.history.pushState({}, '', '/job_finder');
            }}
          >
            {activeService === 'job_finder' ? '• ' : '  '} Find a Job
          </li>
          <li 
            className={`sidebar-item ${activeService === 'pricing' ? 'active' : ''}`}
            onClick={() => { 
                if(isOpen) setActiveService('pricing'); 
                window.history.pushState({}, '', '/pricing');
            }}
          >
            {activeService === 'pricing' ? '• ' : '  '} Pricing
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
